import Usuarios from "@/views/Usuarios.vue";

const usuarios = {
  path: "/app/usuarios",
  name: "usuarios",
  component: Usuarios,
};

export default usuarios;
